/**
 * API для работы с дедлайнами заказов
 */

import { http } from './http'
import { logger } from '../utils/logger'

export interface DeadlineInfo {
  confirmed_at: string
  completion_deadline: string
  completion_deadline_formatted: string
  delivery_days: number
  days_remaining: number
  status_text: string
  css_class: string
}

export interface DeadlineResponse {
  success: boolean
  deadline: DeadlineInfo | null
  message?: string
}

/**
 * Получение информации о дедлайне заказа
 */
export const getOrderDeadline = async (orderId: string): Promise<DeadlineResponse> => {
  try {
    const response = await http.get(`/orders/${orderId}/deadline`)
    return response.data
  } catch (error: any) {
    logger.error('❌ Ошибка получения дедлайна заказа:', error)
    
    // Если дедлайн не найден - это не ошибка
    if (error.response?.status === 404 || error.response?.data?.message?.includes('не установлен')) {
      return {
        success: true,
        deadline: null,
        message: 'Дедлайн не установлен'
      }
    }
    
    throw error
  }
}

/**
 * Очистить старые дедлайны заказа
 */
export const clearOrderDeadline = async (orderId: string): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await http.delete(`/orders/${orderId}/deadline`)
    return response.data
  } catch (error: any) {
    logger.error('❌ Ошибка очистки дедлайна заказа:', error)
    throw error
  }
}
